import { getAccessToken } from "./cookies";
import { urlFor, postJson, TARGET_ACCESS, RequestAccess } from "./comms";

export async function hasAccess() {
    try {
        const accessToken = getAccessToken();
        const targetUrl = urlFor(TARGET_ACCESS);
        const requestAccess = new RequestAccess(accessToken);

        return postJson(targetUrl, requestAccess)
            .then(() => true)
            .catch(() => false);
    } catch (error) {
        return Promise.resolve(false);
    }
};

export async function hasFullAccess() {
    try {
        const accessToken = getAccessToken();
        const targetUrl = urlFor(TARGET_ACCESS);
        const requestAccess = new RequestAccess(accessToken);

        return postJson(targetUrl, requestAccess)
            .then((responseAccess) => responseAccess.is_full)
            .catch(() => false);
    } catch (error) {
        return Promise.resolve(false);
    }
};


